<form class="formNettingAccount" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" color="accent">
        <mat-label>Nom</mat-label>
        <input matInput required formControlName="prelevement_name" type="text" [readonly]="asEdited">
        <mat-hint>Obligatoire</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent" class="input-width">
        <mat-label>Date second taux</mat-label>
        <input matInput formControlName="date_second_rate" type="date" [readonly]="asEdited">
        <mat-hint>Optionnel</mat-hint>
    </mat-form-field>


    <button mat-raised-button class="btn_created" color="primary" type="submit" [disabled]="!formGroup.valid"
        *ngIf="!asEdited && !btnStatus">Créer
    </button>
    <button mat-raised-button class="btn_annuler" color="accent" type="button" (click)="clear()">Annuler</button>
    <button mat-raised-button class="btn_valid" type="submit" [disabled]="!formGroup.valid"
        *ngIf="!asEdited && btnStatus">Valider
    </button>
    <button mat-raised-button class="btn_edit" *ngIf="asEdited" (click)="is_edit(asEdited)">Editer</button>
    <button mat-raised-button class="btn_supp" color="warn" *ngIf="asEdited" (click)="confirmDelete()">Supprimer
    </button>

</form>